// extracted by mini-css-extract-plugin
export var container = "dream-module--container--dd19e";
export var desc = "dream-module--desc--daff6";
export var dream = "dream-module--dream--90488";
export var info = "dream-module--info--72026";
export var orangeBg = "dream-module--orange-bg--b4413";
export var purpleBg = "dream-module--purple-bg--af21c";
export var yellowBg = "dream-module--yellow-bg--06dc7";